export type Columns = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

const breakpointNames = ['Xs', 'Sm', 'Md', 'Lg', 'Xl'] as const;

export const classNameMapper =
  (styles: CSSModuleClasses, keyword: string = '') =>
  (breakpoint: Columns | undefined, idx: number) =>
    breakpoint ? styles[`col${breakpointNames[idx]}${keyword}${breakpoint}`] : undefined;
